export default __webpack_public_path__ + "images/68cd4ab8d1881d6b9678b59141a61b60-gaming.webp";